// Implements: F-GEN-033, F-USG-006
/**
 * When a stored diagram was drawn, as the v3 drawn line says it: "hoy a las 10:24" for a diagram
 * drawn on the reader's today, "el 16 oct." for any other day (mockup v3 P6, `diagramPane`).
 *
 * The moment is the `drawn_at` of the version's costs (C7.1: the run that drew it), read in the
 * reader's own zone, written in the platform locale and on its 24-hour clock (`types/locale.ts`),
 * whatever the browser's. `now` is passed in, so no test depends on the wall clock (checklist 16).
 * A moment that cannot be read is `null`: the line then says no time rather than a wrong one.
 */

import { PLATFORM_HOUR_CYCLE, PLATFORM_LOCALE } from "../../../types/locale";

export type DrawnWhen =
  | { readonly kind: "today"; readonly time: string }
  | { readonly kind: "day"; readonly day: string };

const TIME = new Intl.DateTimeFormat(PLATFORM_LOCALE, {
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: PLATFORM_HOUR_CYCLE,
});

const DAY = new Intl.DateTimeFormat(PLATFORM_LOCALE, { day: "numeric", month: "short" });

function sameDay(left: Date, right: Date): boolean {
  return (
    left.getFullYear() === right.getFullYear() &&
    left.getMonth() === right.getMonth() &&
    left.getDate() === right.getDate()
  );
}

export function drawnWhen(drawnAt: string, now: Date): DrawnWhen | null {
  const drawn = new Date(drawnAt);
  if (Number.isNaN(drawn.getTime())) return null;
  return sameDay(drawn, now) ? { kind: "today", time: TIME.format(drawn) } : { kind: "day", day: DAY.format(drawn) };
}
